import React from 'react';
import GetStarted from '../components/GetStarted';

export default function GetStartedPage() {
  return <GetStarted />;
}
